import { Degree } from "./types";

export const getHighestDegree = (degrees: Degree[]): Degree => {
    const degreeOrder: Degree[] = [
        Degree.CAP_BEP,
        Degree.BP,
        Degree.BAC_1,
        Degree.BAC_2,
        Degree.BAC_3,
        Degree.BAC_4,
        Degree.BAC_5,
        Degree.BAC_6,
        Degree.DOCTORATE,
        Degree.CHERCHEUR,
        Degree.ADDITIONAL_MENTION,
    ];

    let highestDegree = null;
    degrees.forEach((degree) => {
        if (degreeOrder.indexOf(degree) > degreeOrder.indexOf(highestDegree)) {
            highestDegree = degree;
        }
    });

    return highestDegree;
};
